import { SearchRequestBase } from '../SearchRequestBase'

export class FixedInboxSearchRequest extends SearchRequestBase {
  public insuranceCompany?: string
  public providerGroupPaymentTier?: string
  public providerTypeAbbreviation?: string
  public providerGroup?: string
  public notInvoiced?: boolean
  public hasInvoice?: boolean
  public eocStatus?: string
  public quoteTypes?: number[]
}
